import * as common from './common.json';

export const th = {
  common,
};
